module.exports = __webpack_public_path__ + "img/firex-logo.931f3ce2.jpeg";